/** Standard drawer widths for order CRUD pages (Purchase Order reference). */
export const DRAWER_WIDTH = {
  addItems: "min(100vw, max(760px, 65vw))",
  editMultiple: "min(100vw, max(760px, 65vw))",
  note: "min(100vw, max(480px, 40vw))",
  settings: "min(100vw, max(480px, 40vw))",
  files: 1240,
  tasks: 880,
  share: "min(100vw, max(480px, 45vw))",
  activityLog: 540,
  relationshipGraph: "min(100vw, max(690px, 52.5vw))",
};

/** @deprecated use DRAWER_WIDTH.addItems */
export const ADD_ITEMS_DRAWER_WIDTH = DRAWER_WIDTH.addItems;
